/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { LockedDaysResponse } from '../model';
/**
 * LockedDaysControllerApi - axios parameter creator
 * @export
 */
export const LockedDaysControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockedDaysForPartnerBySuperAdmin: async (partnerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getLockedDaysForPartnerBySuperAdmin', 'partnerId', partnerId)
            const localVarPath = `/locked-days/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LockedDaysControllerApi - functional programming interface
 * @export
 */
export const LockedDaysControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LockedDaysControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLockedDaysForPartnerBySuperAdmin(partnerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockedDaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLockedDaysForPartnerBySuperAdmin(partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LockedDaysControllerApi - factory interface
 * @export
 */
export const LockedDaysControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LockedDaysControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockedDaysForPartnerBySuperAdmin(partnerId: string, options?: any): AxiosPromise<LockedDaysResponse> {
            return localVarFp.getLockedDaysForPartnerBySuperAdmin(partnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LockedDaysControllerApi - object-oriented interface
 * @export
 * @class LockedDaysControllerApi
 * @extends {BaseAPI}
 */
export class LockedDaysControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockedDaysControllerApi
     */
    public getLockedDaysForPartnerBySuperAdmin(partnerId: string, options?: AxiosRequestConfig) {
        return LockedDaysControllerApiFp(this.configuration).getLockedDaysForPartnerBySuperAdmin(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
}

